<template>
  <f7-page name="home">
    <wuju-navbar :menu="true" :back="true"></wuju-navbar>
    <wuju-banner title="Insights"></wuju-banner>
    <div v-if="sortedInsights.length">
      <f7-card v-for="(insight, index) in sortedInsights" :key="index">
        <f7-card-content>
          <div class="rows" style="margin-top: 0" v-html="linebreaks(insight.text, 'normal')"></div>
        </f7-card-content>
        <f7-card-footer>
          <p class="flex">{{insight.feeling ? (insight.feeling + ',') : ''}} {{moment(insight.date).fromNow()}}</p>
        </f7-card-footer>
      </f7-card>
    </div>
    <f7-block v-if="! sortedInsights.length">
      <p class="center">There are no insights here yet. Anything you write down as part of your process will appear here.</p>
    </f7-block>
  </f7-page>
</template>

<script>
import moment from 'dayjs';
import Utils from '../js/utils.js';

export default {
  methods: {
    moment: moment,
    ...Utils,
  },
  computed: {
    sortedInsights() {
      return this.$storage.insights.get().filter((v) => !!v.text).sort((a, b) => moment(b.date) - moment(a.date));
    }
  }
}

</script>
